
<template>
  <div class="onboarding-special-page">
    <upgradePlan/>
  </div>
</template>

<script>
import upgradePlan from '@/components/onboarding/upgradePlan/upgradePlan';

export default {
  name: 'onboardingSpecial',
  components: {
    upgradePlan,
  },

  created () {
    if (this.$store.getters['user/isSpecial']) {
      this.$router.replace({ name: 'settings' });
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
